import inr from "../../assets/images/currency-flags/inr.svg";
import usd from "../../assets/images/currency-flags/usd.svg";
import nzd from "../../assets/images/currency-flags/nzd.svg";
import gbp from "../../assets/images/currency-flags/gbp.svg";
import aud from "../../assets/images/currency-flags/aud.svg";
import cad from "../../assets/images/currency-flags/cad.svg";
import uah from "../../assets/images/currency-flags/uah.svg";
import cny from "../../assets/images/currency-flags/cny.svg";
import mxn from "../../assets/images/currency-flags/mxn.svg";
import aed from "../../assets/images/currency-flags/aed.svg";
import sgd from "../../assets/images/currency-flags/sgd.svg";
import eur from "../../assets/images/currency-flags/eur.svg";
import myr from "../../assets/images/currency-flags/myr.svg";
import zar from "../../assets/images/currency-flags/zar.svg";
import thb from "../../assets/images/currency-flags/thb.svg";
import omr from "../../assets/images/currency-flags/omr.svg";
import gel from "../../assets/images/currency-flags/gel.svg";
import amd from "../../assets/images/currency-flags/amd.svg";
import hkd from "../../assets/images/currency-flags/hkd.svg";
import mop from "../../assets/images/currency-flags/mop.svg";

export default [
  { name: "INR", url: inr, symbol: "₹" },
  { name: "USD", url: usd, symbol: "$" },
  { name: "NZD", url: nzd, symbol: "NZ$" },
  { name: "GBP", url: gbp, symbol: "£"  },
  { name: "AUD", url: aud, symbol: "A$" },
  { name: "CAD", url: cad, symbol: "C$" },
  { name: "UAH", url: uah, symbol: "₴" },
  { name: "CNY", url: cny, symbol: "¥" },
  { name: "MXN", url: mxn, symbol: "Mex$" },
  { name: "AED", url: aed, symbol: "AED" },
  { name: "SGD", url: sgd, symbol: "S$" },
  { name: "EUR", url: eur, symbol: "€" },
  { name: "MYR", url: myr, symbol: "RM" },     
  { name: "ZAR", url: zar, symbol: "R" },      
  { name: "THB", url: thb, symbol: "฿" },      
  { name: "OMR", url: omr, symbol: "﷼" },     
  { name: "GEL", url: gel, symbol: "₾" },     
  { name: "AMD", url: amd, symbol: "֏" },     
  { name: "HKD", url: hkd, symbol: "HK$" },   
  { name: "MOP", url: mop, symbol: "MOP$" },  
];
